import RadioButton from "./RadioButton";
import "./RadioButtonGroup.css";

interface RadioButtonGroupProps {
    options: string[];
    selectedIndex: number;
    onChange: (selectedIndex: number) => void;
    groupClassName?: string;
}

const RadioButtonGroup = (props: RadioButtonGroupProps) => {
    const { options, selectedIndex, onChange, groupClassName } = props;

    return (
        <div className={`radio-button-group ${groupClassName}`}>
            {options.map((option, index) => (
                <RadioButton
                    key={option}
                    label={option}
                    checked={selectedIndex === index}
                    onChange={() => onChange(index)}
                />
            ))}
        </div>
    );
};

export default RadioButtonGroup;
